export function showCta(ctaData) {
  return ctaData && ctaData.title;
}
export default {
  showCta,
};
